export default {
  props: {
    modelValue: {
      type: Number,
      default: 0,
    },
    validate: Function,
    initial: {
      type: Number,
      default: 0,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      lastCorrect: this.modelValue,
      min: 5,
      max: 94, // coz 99 - 5
      invalid: false,
      val: 0,
      focused: false,
    };
  },
  computed: {
    valueWithCent() {
      return this.focused ? this.val : `${this.val}¢`;
    },
  },
  created() {
    this.val = this.modelValue;
  },
  methods: {
    updateValue(value) {
      if (value === '') {
        return;
      }

      const parsed = Number.parseInt(value, 10);
      if (Number.isNaN(parsed)) {
        this.$refs.input.value = this.lastCorrect;
        return;
      }

      if (`${parsed}` !== value) {
        this.$refs.input.value = this.lastCorrect;
        return;
      }

      if (value > this.max) {
        this.lastCorrect = this.max;
        this.$refs.input.value = this.max;
        return;
      }

      this.lastCorrect = parsed;
    },
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      this.focused = false;
      this.val = this.lastCorrect;

      if (this.$refs.input.value === '') {
        this.val = this.min;
      }
      if (this.lastCorrect < this.min) {
        this.val = this.min;
      }

      if (this.lastCorrect > this.max) {
        this.val = this.max;
      }

      this.$refs.input.value = `${this.val}¢`;
      this.$emit('update:modelValue', this.val);
    },
  },
};
